module.exports = __webpack_public_path__ + "05ca3bd2573d1802b9e1862da21dc080.pdf";